// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/shopping-promo/shopping-promo.component.scss
// module id = 141
// module chunks = 0